// The admin's own public ordering link for a given school — schoolId (the
// one being managed, from the /admin/:schoolId/... route) doubles as the
// subdomain label on this deployment's own base domain (see AGENTS.md's
// "Schools are database-backed" / backend/schoolstore.Store.ForHost).
//
// "This deployment's own base domain" is the admin dashboard's current
// hostname, but with any *other* school's subdomain label stripped off
// first — an admin can visit "/admin/:schoolId/..." from any school's own
// subdomain, not just the bare base domain (e.g. viewing the middle
// school's orders while parked on the elementary school's own
// "lhelions.lunchday.app"), so the current hostname is not reliably the
// base domain on its own. knownSchoolIds (every school id the admin can
// see — see SchoolContext) is how this tells "lhelions.lunchday.app" apart
// from a genuine base domain with no label at all: if the current
// hostname's left-most label matches a real school id, that label is
// stripped before schoolId is prepended, so the result is always
// "<schoolId>.<real base domain>" regardless of which school's subdomain
// the admin happens to be browsing from.
//
// In local dev the host (e.g. "localhost:3000") has no real subdomain
// scheme to construct against — mirrors backend's loginURLForSchool,
// which likewise leaves a non-production host unchanged rather than
// prepending a made-up label.
//
// Shared by Help.js (the "Advertise your lunch days" step) and
// AdminDashboard.js (the account menu's "copy ordering link" action) —
// keep both call sites in sync if this changes.
export function schoolOrderingLink(schoolId, knownSchoolIds = []) {
  const { protocol, hostname, port } = window.location;
  const portSuffix = port ? `:${port}` : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}${portSuffix}`;
  }

  let baseDomain = hostname;
  const dot = hostname.indexOf('.');
  if (dot > 0) {
    const label = hostname.slice(0, dot);
    if (knownSchoolIds.includes(label)) {
      baseDomain = hostname.slice(dot + 1);
    }
  }

  return `${protocol}//${schoolId}.${baseDomain}${portSuffix}`;
}
